/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HomeownershipFinancing } from './HomeownershipFinancing';
import {
    HomeownershipFinancingFromJSON,
    HomeownershipFinancingFromJSONTyped,
    HomeownershipFinancingToJSON,
} from './HomeownershipFinancing';
import type { HomeownershipLockStatus } from './HomeownershipLockStatus';
import {
    HomeownershipLockStatusFromJSON,
    HomeownershipLockStatusFromJSONTyped,
    HomeownershipLockStatusToJSON,
} from './HomeownershipLockStatus';
import type { HomeownershipRepresentation } from './HomeownershipRepresentation';
import {
    HomeownershipRepresentationFromJSON,
    HomeownershipRepresentationFromJSONTyped,
    HomeownershipRepresentationToJSON,
} from './HomeownershipRepresentation';

/**
 * 
 * @export
 * @interface HomeownershipLockBlock
 */
export interface HomeownershipLockBlock {
    /**
     * 
     * @type {string}
     * @memberof HomeownershipLockBlock
     */
    contractDeadlineDate?: string;
    /**
     * 
     * @type {HomeownershipLockStatus}
     * @memberof HomeownershipLockBlock
     */
    status: HomeownershipLockStatus;
    /**
     * 
     * @type {HomeownershipRepresentation}
     * @memberof HomeownershipLockBlock
     */
    representation?: HomeownershipRepresentation;
    /**
     * 
     * @type {HomeownershipFinancing}
     * @memberof HomeownershipLockBlock
     */
    financing?: HomeownershipFinancing;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipLockBlock
     */
    coBuyerName?: string;
    /**
     * 
     * @type {Date}
     * @memberof HomeownershipLockBlock
     */
    lockedAt?: Date;
}

/**
 * Check if a given object implements the HomeownershipLockBlock interface.
 */
export function instanceOfHomeownershipLockBlock(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function HomeownershipLockBlockFromJSON(json: any): HomeownershipLockBlock {
    return HomeownershipLockBlockFromJSONTyped(json, false);
}

export function HomeownershipLockBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeownershipLockBlock {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'contractDeadlineDate': !exists(json, 'contract_deadline_date') ? undefined : json['contract_deadline_date'],
        'status': HomeownershipLockStatusFromJSON(json['status']),
        'representation': !exists(json, 'representation') ? undefined : HomeownershipRepresentationFromJSON(json['representation']),
        'financing': !exists(json, 'financing') ? undefined : HomeownershipFinancingFromJSON(json['financing']),
        'coBuyerName': !exists(json, 'co_buyer_name') ? undefined : json['co_buyer_name'],
        'lockedAt': !exists(json, 'locked_at') ? undefined : (new Date(json['locked_at'])),
    };
}

export function HomeownershipLockBlockToJSON(value?: HomeownershipLockBlock | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'contract_deadline_date': value.contractDeadlineDate,
        'status': HomeownershipLockStatusToJSON(value.status),
        'representation': HomeownershipRepresentationToJSON(value.representation),
        'financing': HomeownershipFinancingToJSON(value.financing),
        'co_buyer_name': value.coBuyerName,
        'locked_at': value.lockedAt === undefined ? undefined : (value.lockedAt.toISOString()),
    };
}

